import Leaflet from "leaflet";
import "leaflet-providers";
import { GridLayer } from "react-leaflet";

export default class ExtraTileLayer extends GridLayer {
  createLeafletElement({ name, ...options }) {
    return Leaflet.tileLayer.provider(name, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/map/ExtraTileLayer.js